import { render, staticRenderFns } from "./UrlOgReview.vue?vue&type=template&id=cee92f8c&"
import script from "./UrlOgReview.vue?vue&type=script&lang=js&"
export * from "./UrlOgReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports